import React from "react";

export default function UserPrivacyPolicy() {
  const sections = [
  {
    title: "1. Purpose of Policy",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
        <li>This Privacy Policy explains how BGT Groups collects and uses customer information.</li>
        <li>BGT Groups is committed to ensuring protection of your privacy.</li>
        <li>Policy may be updated periodically; users are responsible for reviewing changes.</li>
      </ul>
    ),
  },

  {
    title: "2. Information We Collect",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
        <li>Name.</li>
        <li>Contact information including email address.</li>
        <li>Demographic data such as postcode, interests, and preferences.</li>
        <li>Other relevant customer survey or offer-related information.</li>
      </ul>
    ),
  },

  {
    title: "3. How We Use Collected Information",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
        <li>Maintain internal records.</li>
        <li>Improve products and services.</li>
        <li>Send promotional emails on new products/offers (if permitted).</li>
        <li>Conduct customer research via email, phone, fax, or mail.</li>
        <li>Customize website based on customer interests.</li>
        <li>Ensure reasonable measures to prevent unauthorized access or disclosure.</li>
      </ul>
    ),
  },

  {
    title: "4. Use of Cookies",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
        <li>Cookies are small files stored on your device with permission.</li>
        <li>Cookies help analyze web traffic and personalize website experience.</li>
        <li>Traffic log cookies are used only for statistical analysis; data is removed thereafter.</li>
        <li>Cookies do not grant access to personal device information.</li>
        <li>You may accept or decline cookies using browser settings.</li>
      </ul>
    ),
  },

  {
    title: "5. Controlling Personal Information",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
        <li>Users may restrict collection/use of information through form options.</li>
        <li>Users may withdraw marketing consent anytime via email or written request.</li>
        <li>Personal data will not be sold, leased, or distributed to third parties without consent unless required by law.</li>
        <li>Users may opt-in to receive promotional information from third parties.</li>
      </ul>
    ),
  },

  {
    title: "6. Accuracy & Corrections",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
        <li>If stored information is incorrect or incomplete, users may request corrections.</li>
        <li>Correction requests can be submitted in writing to the registered address.</li>
        <li>BGT Groups will update incorrect information promptly upon verification.</li>
      </ul>
    ),
  },

  {
    title: "7. Contact Address",
    content: (
      <p style={{ color: "#6C757D", paddingLeft: "20px" }}>
        Address: 0, 50.1.40, ASLM-1422, ASM, Visakhapatnam, Andhra Pradesh, 530013 P and T Colony (VM)
      </p>
    ),
  },
];



  return (
    <div
      style={{
        backgroundColor: "#F8F9FA",
        padding: "100px 20px",
        fontFamily: "'Inter', sans-serif",
        color: "#1C1C1C",
        lineHeight: "1.8",
      }}
    >
      <h1
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: "3rem",
          background: "linear-gradient(90deg, #E63946, #FFC300)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "50px",
          textAlign: "center",
        }}
      >
        User Privacy Policy
      </h1>

      {sections.map((section, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#FFFFFF",
            padding: "30px",
            borderRadius: "15px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
            marginBottom: "30px",
          }}
        >
          <h2
            style={{
              fontFamily: "'Poppins', sans-serif",
              color: "#E63946",
              paddingBottom: "10px",
              marginBottom: "20px",
            }}
          >
            {section.title}
          </h2>
          {section.content}
        </div>
      ))}
    </div>
  );
};
